<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t4' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.cargaDoc != null">
            <span class="nav-link-in">
              Notas fiscais
              <i class="fa fa-file-text"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t3' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.cargaDoc != null">
            <span class="nav-link-in">
              CTes
              <i class="fa fa-file-text-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t2' + rowData.cargaId + ''" role="tab" data-toggle="tab" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
            <span class="nav-link-in">
              Roterizador
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t1' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor != 1">
            <span class="nav-link-in">
              Status integrações
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t5' + rowData.cargaId + ''" role="tab" data-toggle="tab"
          v-if="errors.length > 0 || rowData.integracaoLog.length > 0">
            <span class="nav-link-in">
              Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t6' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.pessoaParceira != null">
            <span class="nav-link-in">
              Pessoa Parceira
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t7' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor == 3">
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t8' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor == 3">
            <span class="nav-link-in">
              Vale pedagio
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t9' + rowData.cargaId + ''" role="tab" data-toggle="tab" v-if="
            rowData.cargaMeioTransp != null &&
            rowData.cargaMeioTransp.cargaMeioTranspAjudante.length > 0
          ">
            <span class="nav-link-in">
              Ajudantes
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade show pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + rowData.cargaId + ''">
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N nota</th>
                <th style="width: 5%">Série</th>
                <th style="width: 5%">Data emissão</th>
                <th style="width: 45%">Cliente</th>
                <th style="width: 5%">Peso bruto</th>
                <th style="width: 5%">Peso liquído</th>
                <th style="width: 5%">Vlr. nota</th>
                <th style="width: 5%">Volume</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDoc">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.docFiscal.numFiscal }}
                </td>
                <td>
                  {{ item.docFiscal.serie }}
                </td>
                <td>
                  {{ formatDate(item.docFiscal.dtEmi) }}
                </td>
                <td>
                  {{ item.docFiscal.docFiscalPartesEnv.desNome }} -
                  {{ item.docFiscal.docFiscalPartesEnv.desCnpj }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docPesoBruto) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docPesoLiquido) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docFiscalVlrTotal) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.volume) }}
                </td>
                <td>
                  <a @click="onDetailDoc(item.cardocId)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetailRowDoc(item.cardocId)">
                <td colspan="10">
                  <section class="tabs-section">
                    <ul class="nav nav-tabs nav-topline nav-justified" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" v-bind:href="'#docfis1' + item.cardocId + ''" role="tab"
                          data-toggle="tab">
                          <span class="nav-link-in">
                            Itens
                            <i class="fa fa-cubes"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" v-bind:href="'#docfis2' + item.cardocId + ''" role="tab" data-toggle="tab">
                          <span class="nav-link-in">
                            Volumes
                            <i class="fa fa-cube"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" v-bind:href="'#docfis3' + item.cardocId + ''" role="tab" data-toggle="tab">
                          <span class="nav-link-in">
                            Partes Env.
                            <i class="fa fa-cube"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis1' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 30%">Descrição</th>
                              <th style="width: 10%">NCM</th>
                              <th style="width: 10%">CFOP</th>
                              <th style="width: 10%">Vlr. Bruto</th>
                              <th style="width: 10%">Peso liquído</th>
                            </tr>
                          </thead>
                          <tbody v-for="item2 in item.docFiscal.docFiscalProduto">
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                {{ item2.descr }}
                              </td>
                              <td>
                                {{ item2.ncm }}
                              </td>
                              <td>
                                {{ item2.cfop }}
                              </td>
                              <td>
                                {{ formatNumber(item2.vlrBruto) }}
                              </td>
                              <td>
                                {{ formatNumber(item2.qtdComercial) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis2' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 33%">Etiqueta</th>
                              <th style="width: 33%">Peso Bruto</th>
                              <th style="width: 34%">Volume</th>
                            </tr>
                          </thead>
                          <tbody v-for="item2 in item.docFiscal.docFiscalTransporte
                            .docFiscalTransporteVolume">
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                {{ item2.especieVolume }}
                              </td>
                              <td>
                                {{ formatNumber(item2.pesoBruto) }}
                              </td>
                              <td>
                                {{ formatNumber(item2.qtdVolume) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis3' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 10%"></th>
                              <th style="width: 20%">CNPJ/CPF</th>
                              <th style="width: 20%">Nome</th>
                              <th style="width: 20%">Endereço</th>
                              <th style="width: 20%">Municipio</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-primary">Emitente</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.emiCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.emiCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                {{ item.docFiscal.docFiscalPartesEnv.emiNome }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.emiEndereco
                                }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv
                                    .emiNomeMunicipio
                                }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-warning">Destinatário</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.desCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.desCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.desCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.desCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                {{ item.docFiscal.docFiscalPartesEnv.desNome }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.desEndereco
                                }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv
                                    .desNomeMunicipio
                                }}
                              </td>
                            </tr>
                          </tbody>

                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-info">Redespacho</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.redCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.redCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redNome !=
                                  null
                                ">{{
                                    item.docFiscal.docFiscalPartesEnv.redNome
                                  }}</span>
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.redEndereco
                                }}
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv
                                    .redNomeMunicipio != null
                                ">{{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redNomeMunicipio
                                  }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.cargaId + ''" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Sequência</th>
                <th data-toggle="true" style="width: 10%">Nota fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.cargaSequenciaEntrega">
                <td>
                  {{ item.sequencia }}
                </td>
                <td>
                  {{ item.docFiscalNumFiscal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. fiscal</th>
                <th data-toggle="true" style="width: 90%">Série</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in rowData.cargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.numFiscal
                    }}</span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.serie
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.cargaId + ''" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Sequência</th>
                <th data-toggle="true" style="width: 10%">Nota fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.cargaSequenciaEntrega">
                <td>
                  {{ item.sequencia }}
                </td>
                <td>
                  {{ item.docFiscalNumFiscal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. fiscal</th>
                <th data-toggle="true" style="width: 90%">Série</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in rowData.cargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.numFiscal
                    }}</span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.serie
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Integração</th>
                <th data-toggle="true" style="width: 60%">Descrição</th>
                <th data-toggle="true" style="width: 20%">Status</th>
                <th data-toggle="true" style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-if="rowData.statusProcessoExpedicao.valor != 1">
              <tr class="bg-gray-light" style="display: table-row"
                v-for="item in rowData.statusIntegracoes.statusOpentech">
                <td>
                  <span class="badge badge-primary">Opentech</span>
                </td>
                <td>
                  {{ item.tipo }} - {{ item.descr }} - {{ item.situacao }}
                </td>
                <td>
                  <span v-if="item.status.valor == 2" class="badge badge-danger">{{ item.status.descr }}</span>
                  <span v-if="item.status.valor == 1" class="badge badge-success">{{ item.status.descr }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.statusIntegracoes.averbacao">
                <td>
                  <span class="badge badge-primary">Averbação</span>
                </td>
                <td>DOC: {{ item.num_doc }} - {{ item.serie }}</td>
                <td>
                  <span v-if="item.status.valor == 2" class="badge badge-danger">{{ item.status.descr }}</span>
                  <span v-if="item.status.valor == 1" class="badge badge-success">{{ item.status.descr }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Iroute</span>
                </td>
                <td></td>
                <td>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 3" class="badge badge-success">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 2" class="badge badge-danger">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 1" class="badge badge-warning">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Roteiro</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetRoteiro.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusTargetRoteiro.status.descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetRoteiro.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusTargetRoteiro.status.descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <template v-if="rowData.statusIntegracoes && rowData.statusIntegracoes.hybrid">
                <template v-if="rowData.statusIntegracoes.hybrid.cte && rowData.statusIntegracoes.hybrid.rps">
                  <template v-if="rowData.statusIntegracoes.hybrid.cte.length === 0 && rowData.statusIntegracoes.hybrid.rps.length === 0">
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        <span class="badge badge-primary">CTE Interno</span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui CTE Receita
                        </span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui CTE Receita
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.hybrid.cte" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">CTE Receita</span>
                      </td>
                      <td>
                        Nota: {{ item.num_fiscal_nota }} - {{ item.serie_nota}}, Doc: {{ item.num_fiscal_doc }} - {{ item.serie_doc }}
                      </td>
                      <td>
                        <span :class="getBadgeClassStatusSefaz(item.status.valor)">
                          {{ item.status.descr }}
                          <i class="fa fa-question-circle-o fa-lg" v-b-tooltip.hover.top="item.status.motivo"></i>
                        </span>
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.hybrid.rps" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">RPS Receita</span>
                      </td>
                      <td>
                        Nota: {{ item.num_fiscal_nota }} - {{ item.serie_nota }}, Doc: {{ item.num_fiscal_doc }} - {{ item.serie_doc }}
                      </td>
                      <td>
                        <span :class="getBadgeClassStatusRps(item.status.valor)">
                          {{ item.status.descr }}
                          <i class="fa fa-question-circle-o fa-lg" v-b-tooltip.hover.top="item.status.motivo"></i>
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      <span class="badge badge-primary">CTE Receita</span>
                    </td>
                    <td>{{ rowData.statusIntegracoes.hybrid.descr }}</td>
                    <td>
                      <span :class="getBadgeClassStatusSefaz(rowData.statusIntegracoes.hybrid.valor)">
                        {{ rowData.statusIntegracoes.hybrid.descr }}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span class="badge badge-primary">CTE Receita</span>
                  </td>
                  <td colspan="3">
                    Nenhuma integração encontrada.
                  </td>
                </tr>
              </template>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Carregamento Despesa</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusCarregamentoDespesa.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusCarregamentoDespesa.status
                        .descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusCarregamentoDespesa.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusCarregamentoDespesa.status
                        .descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <template v-if="rowData.statusIntegracoes && rowData.statusIntegracoes.nstech">
                <template v-if="Array.isArray(rowData.statusIntegracoes.nstech)">
                  <template v-if="rowData.statusIntegracoes.nstech.length === 0">
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        <span class="badge badge-primary">NSTech</span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui integração na NSTech
                        </span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui integração na NSTech
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.nstech" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">NSTech</span>
                      </td>
                      <td>
                        Nota: {{ item.num_doc }} - {{ item.serie }}
                      </td>
                      <td>
                        <span :class="getBadgeClassIntegracao(item.status.valor)">
                          {{ item.status.descr }}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      <span class="badge badge-primary">NSTech</span>
                    </td>
                    <td>{{ rowData.statusIntegracoes.nstech.descr }}</td>
                    <td>
                      <span :class="getBadgeClassExpedicao(rowData.statusIntegracoes.nstech.valor)">
                        {{ rowData.statusIntegracoes.nstech.descr }}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span class="badge badge-primary">NSTech</span>
                  </td>
                  <td colspan="3">
                    Nenhuma integração encontrada.
                  </td>
                </tr>
              </template>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Ciot</span>
                </td>
                <td></td>
                <td>
                  <span
                    v-if="
                      rowData.statusIntegracoes.statusTargetCiot &&
                      rowData.statusIntegracoes.statusTargetCiot.status.valor == 2
                    "
                    class="badge badge-danger"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                  <span
                    v-else-if="
                      rowData.statusIntegracoes.statusTargetCiot &&
                      rowData.statusIntegracoes.statusTargetCiot.status.valor == 3
                    "
                    class="badge badge-warning"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                  <span
                    v-else-if="rowData.statusIntegracoes.statusTargetCiot"
                    class="badge badge-success"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onCancelaCiot(rowData.cargaId, 5, rowData)"
                    v-if="canShowCancelCiotButton(rowData)"
                    v-b-tooltip
                    :title="getCancelCiotTitle(rowData)"
                    ><i class="fa fa-times-circle"></i
                  ></a>
                </td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Pedagio</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetPedagio.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusTargetPedagio.status.descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetPedagio.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusTargetPedagio.status.descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row"
                v-for="item in rowData.statusIntegracoes.statusTracking">
                <td>
                  <span class="badge badge-primary">Tracking</span>
                </td>
                <td>Nota: {{ item.num_docfis }} - {{ item.serie }}</td>
                <td>
                  <span v-if="item.status.valor == 2" class="badge badge-danger">{{ item.status.descr }}</span>
                  <span v-if="item.status.valor == 1" class="badge badge-success">{{ item.status.descr }}</span>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.cargaId + ''" v-if="errors.length > 0 || rowData.integracaoLog.length > 0">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Entidade</th>
                <th data-toggle="true" style="width: 80%">Descrição</th>
                <th data-toggle="true" style="width: 3%">Qtde</th>
                <th data-toggle="true" style="width: 10%">
                  Data Primeira e Ultima Ocorrencia
                </th>
              </tr>
            </thead>
            <tbody v-if="errors.length > 0" v-for="item in errors">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary" v-b-tooltip.hover.top="item.id">{{ item.entidade }}</span>
                </td>
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  {{ item.qtde }}
                </td>
                <td>
                  {{ formatDateHora(item.dtPrimeiraOcorrencia) }}<br />
                  {{ formatDateHora(item.dtUltimaOcorrencia) }}
                </td>
              </tr>
            </tbody>
            <tbody v-for="item2 in rowData.integracaoLog">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary" v-if="item2.integracaoDescr != null">{{ item2.integracaoDescr
                    }}</span>
                </td>
                <td>
                  {{ item2.descr }}
                </td>
                <td>
                  {{ item2.qtde }}
                </td>
                <td>
                  {{ formatDateHora(item2.dtPrimeiraOcorrencia) }}<br />
                  {{ formatDateHora(item2.dtUltimaOcorrencia) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.cargaId + ''" v-if="rowData.pessoaParceira != null">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Unidade Parceira</th>
                <th data-toggle="true" style="width: 20%">Razão Social</th>
                <th data-toggle="true" style="width: 20%">
                  Unidade Transporte
                </th>
                <th data-toggle="true" style="width: 20%">Motorista</th>
                <th data-toggle="true" style="width: 20%">Placa Primária</th>
              </tr>
            </thead>
            <tbody v-if="rowData.pessoaParceira != null">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.pessoaParceira.descr }}
                </td>
                <td>
                  {{ rowData.pessoaParceira.pessoa.pessoaJuridica.razaoSocial }}
                </td>
                <td>
                  {{ rowData.cargaMeioTransp.paramTipoRodado.descr }}
                </td>
                <td>
                  <span v-if="rowData.cargaMeioTransp.nomeMotorista != null">
                    {{ rowData.cargaMeioTransp.nomeMotorista }}
                  </span>
                  <span v-if="rowData.cargaMeioTransp.nomeMotoristaJuridica != null">
                    {{ rowData.cargaMeioTransp.nomeMotoristaJuridica }}
                  </span>
                </td>
                <td>
                  {{ rowData.cargaMeioTransp.placa }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. MDFE</th>
                <th data-toggle="true" style="width: 10%">Num. Romaneio</th>
                <th data-toggle="true" style="width: 10%">Valor Avulso</th>
                <th data-toggle="true" style="width: 10%">Usuário Despesa</th>
                <th data-toggle="true" style="width: 60%">
                  Observação Despesa
                </th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.manifestos">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="
                    rowData.statusProcessoExpedicao.valor == 3 
                    && rowData.manifestos.length > 0
                  ">{{ item.numFiscal }}</span>
                </td>
                <td>
                  <span v-if="
                    rowData.tpOperacaoPrincipal == 3 &&
                    rowData.manifestos.length == 0 &&
                    rowData.statusProcessoExpedicao.valor == 3
                  ">{{ rowData.numCarga }}</span>
                </td>
                <td>
                  <span v-if="rowData.vlrDespesaAvulso != null">{{
                    formatNumber(rowData.vlrDespesaAvulso)
                    }}</span>
                </td>
                <td>
                  <span v-if="rowData.usuarioIdDespesa != null">{{
                    rowData.usuarioIdDespesa.email
                    }}</span>
                </td>
                <td>
                  <span v-if="rowData.obsDespesa != null">{{
                    rowData.obsDespesa
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Cod. Vale Pedagio</th>
                <th data-toggle="true" style="width: 20%">
                  Valor Vale Pedagio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="
                    rowData.cargaValePedagio != null &&
                    rowData.cargaValePedagio.cdValePedagio != 0
                  ">{{ rowData.cargaValePedagio.cdValePedagio }}</span>
                  <span v-if="
                    rowData.cargaValePedagio == null ||
                    rowData.cargaValePedagio.cdValePedagio == 0
                  ">Sem dados Registrados</span>
                </td>
                <td>
                  <span v-if="
                    rowData.cargaValePedagio != null &&
                    rowData.cargaValePedagio.vlrValePedagio != 0
                  ">{{
                      formatNumber(rowData.cargaValePedagio.vlrValePedagio)
                    }}</span>
                  <span v-if="
                    rowData.cargaValePedagio == null ||
                    rowData.cargaValePedagio.vlrValePedagio == 0
                  ">Sem dados Registrados</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade show pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.cargaId + ''">
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Nome</th>
                <th style="width: 5%">Cpf</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaMeioTransp.cargaMeioTranspAjudante">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.pessoa.pessoaFisica.nome }}
                </td>
                <td>
                  {{ ajustaMascara(item.pessoa.pessoaFisica.cpf) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <MontagemCargaPartesEnvForm ref="montagemcargapartesenv">
      </MontagemCargaPartesEnvForm>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import MontagemCargaPartesEnvForm from "./MontagemCargaPartesEnvForm";
import {
  showCiotIntegrationButton as showCiotIntegrationButtonFn
} from "../utils/expedicaoRowVisibility";

export default {
  components: {
    MontagemCargaPartesEnvForm,
  },
  data() {
    return {
      peso_bruto: "",
      visibleDetailRowsDoc: [],
      helpForm: new Form({ statusRecord: [], params: [] }),
      form: new Form({ carga_id: "", tipo: "" }),
      integracaoMapping: {
        "-3": { class: "badge badge-success", label: "Nota não enviada, pois não exige CTE" },
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Ok, transp não exige NSTech" },
        "0": { class: "badge badge-warning", label: "Aguardando Processar" },
        "1": { class: "badge badge-warning", label: "Nota Enviada Com Sucesso" },
        "2": { class: "badge badge-danger", label: "Erro Ao Enviar Nota" },
        "3": { class: "badge badge-warning", label: "Aguardando CTE" },
        "4": { class: "badge badge-success", label: "CTE Gerado Com Sucesso" },
        "5": { class: "badge badge-danger", label: "Erro Ao Gerar CTE" },
        "6": { class: "badge badge-warning", label: "Aguardando Manifesto" },
        "7": { class: "badge badge-success", label: "Manifesto Gerado Com Sucesso" },
        "8": { class: "badge badge-danger", label: "Erro Ao Gerar Manifesto" },
        "9": { class: "badge badge-warning", label: "Cancelando Carga" },
        "10": { class: "badge badge-success", label: "Carga Cancelada Com Sucesso" },
        "11": { class: "badge badge-danger", label: "Erro Ao Cancelar Carga" },
        "12": { class: "badge badge-success", label: "Carga integrada" },
      },
      expedicaoMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Ok, transp não exige NSTech" },
        "1": { class: "badge badge-danger", label: "Sem integração" },
        "2": { class: "badge badge-warning", label: "Pendente" },
        "3": { class: "badge badge-success", label: "Concluído" },
        "4": { class: "badge badge-danger", label: "Com erro" },
        "5": { class: "badge badge-warning", label: "Em cancelamento" },
        "6": { class: "badge badge-success", label: "Cancelado" },
        "7": { class: "badge badge-danger", label: "Cancelado com erro" },
        "8": { class: "badge badge-success", label: "Não exige CTE" },
      },
      statusSefazMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Não exige criar CTE receita" },

        "1": { class: "badge badge-danger", label: "Pendente" },
        "2": { class: "badge badge-warning", label: "Enviado SEFAZ" },
        "3": { class: "badge badge-warning", label: "Aguardando resposta" },
        "4": { class: "badge badge-success", label: "Autorizado" },
        "5": { class: "badge badge-danger", label: "Rejeitado" },
        "6": { class: "badge badge-danger", label: "Denegado" },
        "7": { class: "badge badge-danger", label: "Cancelado" },
        "8": { class: "badge badge-danger", label: "Inutilizado" },
        "9": { class: "badge badge-danger", label: "Erro" },
      },
      statusRpsMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Não exige criar RPS receita" },

        "1": { class: "badge badge-success", label: "Normal" },
        "2": { class: "badge badge-danger", label: "Cancelado" },
      },
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },

  computed: {
    errors() {
      if (this.rowData.cargaLog == null && this.rowData.docFiscalLog == null) {
        return [];
      }
      let concatLogs = this.rowData.cargaLog.concat(this.rowData.docFiscalLog);

      let mergedLogs = concatLogs.map(function (log) {
        return {
          id: log.carlogId ? log.carlogId : log.docfislogId,
          ...log
        }
      }).sort(function (a, b) {
        return (new Date(b.dtUltimaOcorrencia).getTime()) - (new Date(a.dtUltimaOcorrencia).getTime());
      });

      return mergedLogs;
    },
  },
  methods: {
    onDetailDoc(tabfrerot_id) {
      this.toggleDetailRowDoc(tabfrerot_id);
    },
    isVisibleDetailRowDoc(rowId) {
      return this.visibleDetailRowsDoc.indexOf(rowId) >= 0;
    },
    showDetailRowDoc(rowId) {
      if (!this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.push(rowId);
      }
    },
    hideDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.splice(
          this.visibleDetailRowsDoc.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.hideDetailRowDoc(rowId);
      } else {
        this.showDetailRowDoc(rowId);
      }
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onCancelaCiot(carga_id, tipo, rowData = this.rowData) {
      if (!this.canShowCancelCiotButton(rowData)) {
        return;
      }

      const ciotNumber = this.getCiotNumber(rowData);
      const message = ciotNumber !== "não informado"
        ? `Deseja cancelar o CIOT - ${ciotNumber}?`
        : "Deseja anular a Operação de Transporte?";

      this.$Simplert.open({
        title: "Atenção",
        message,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => {
          this.executeCancelCiot(carga_id, tipo);
        },
      });
    },
    executeCancelCiot(carga_id, tipo) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form.tipo = tipo;
      this.form
        .post("/api/expedicao/integracao/manual")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
      Vue.nextTick(() => {
        this.$parent.$parent.$refs.vuetable.refresh();
      });
    },
    getCiotNumber(shipment) {
      const cargaCiot = shipment && shipment.cargaCiot ? shipment.cargaCiot : null;
      if (!cargaCiot) {
        return "não informado";
      }

      const ciotNumber = cargaCiot.numCiot;
      const ciotNumberText = ciotNumber != null ? String(ciotNumber).trim() : "";

      return ciotNumberText !== "" && /\d/.test(ciotNumberText)
        ? ciotNumber
        : "não informado";
    },
    getCancelCiotTitle(shipment) {
      const ciotNumber = this.getCiotNumber(shipment);
      return ciotNumber !== "não informado"
        ? "Cancelar Ciot"
        : "Anular Operação de Transporte";
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    getBadgeClassIntegracao: function (value) {
      return (this.integracaoMapping[value] && this.integracaoMapping[value].class) || 'badge badge-secondary';
    },
    getBadgeClassExpedicao: function (value) {
      return (this.expedicaoMapping[value] && this.expedicaoMapping[value].class) || 'badge badge-secondary';
    },

    getBadgeClassStatusSefaz: function (value) {
      return (this.statusSefazMapping[value] && this.statusSefazMapping[value].class) || 'badge badge-secondary';
    },

    getBadgeClassStatusRps: function (value) {
      return (this.statusRpsMapping[value] && this.statusRpsMapping[value].class) || 'badge badge-secondary';
    },
    perm(key) {
      return this.getPermissionFw(key);
    },
    showCiotIntegrationButton(shipment) {
      return showCiotIntegrationButtonFn(this.perm, shipment);
    },
    canShowCancelCiotButton(shipment) {
      if (!shipment || shipment.cargaCiot == null) {
        return false;
      }

      const idOperacaoTransporte = shipment.cargaCiot.cdGestaoPagto;
      if (idOperacaoTransporte == null || String(idOperacaoTransporte).trim() === "") {
        return false;
      }

      if (shipment.manifestos == null || shipment.manifestos.length === 0) {
        return true;
      }

      const existsManifestNotCanceled = shipment.manifestos.some(manifesto => {
        const manifestoStatus = manifesto.status;
        const manifestoStatusValor = manifestoStatus && typeof manifestoStatus === "object"
            ? manifestoStatus.valor : manifestoStatus;

        const manifestoStatusNumber = Number(manifestoStatusValor);
        return manifestoStatusNumber !== 9 && manifestoStatusNumber !== 14;
      });

      return !existsManifestNotCanceled;
    },
  },
};
</script>
